import {useNavigate} from 'react-router-dom';
import large_logo from './../../../../../assets/icon/l_logo.png';
import small_logo from './../../../../../assets/icon/s_logo.png';
import './index.style.less';
import {string} from 'prop-types';

const AppLogo = ({type = 'large'}) => {
  const navigate = useNavigate();

  return (
    <div className='app-logo' onClick={() => navigate('/dashboard/home')}>
      {type === 'large' ? (
        <img
          src={large_logo}
          alt='ubl-logo'
          style={{width: '60px', height: 'auto'}}
        />
      ) : (
        <img src={small_logo} alt='ubl-logo' />
      )}
    </div>
  );
};

export default AppLogo;

AppLogo.propTypes = {
  type: string,
};
